<script setup>
import { useTicketStore } from '#modules/support/stores/ticket.store.js';
import { Tooltip as VueTooltip } from 'floating-vue';
import CFKbd from '@/shared/components/CFKbd.vue';
import { defineShortcuts } from '@/app/composables/defineShortcuts.js';
import CFRoundedButton from '@/ui/RoundedButton/CFRoundedButton.vue';

const ticketStore = useTicketStore();

defineShortcuts({
    shift_h: {
        handler: () => {
            if (ticketStore.active) {
                ticketStore.close();
            } else {
                ticketStore.open();
            }
        },
    },
});
</script>

<template>
    <VueTooltip theme="dark-tooltip">
        <CFRoundedButton
            icon="headphones-customer-support"
            color="primary"
            size="lg"
            @click="ticketStore.open()"
        />

        <template #popper>
            <div class="flex flex-col items-center">
                <strong>{{ $t('shortcuts.support') }}</strong>
                <CFKbd
                    value="Shift + H"
                    class="bg-primary text-neutrals-600 ring-primary"
                />
            </div>
        </template>
    </VueTooltip>
</template>
